export const meta = {
  id: 'O01', slug: 'gerenciar-membros', title: 'Como gerenciar Membros',
  description: 'Consulte usuários, papéis, status e ações administrativas disponíveis para cada membro.',
  profile: 'owner', category: 'pessoas', type: 'task', status: 'published', order: 310,
  keywords: ['membros', 'usuários', 'pessoas', 'status', 'papéis'], previous: 'O00', next: 'O02',
  related: ['O03', 'O04'], updatedAt: '2026-08-17', appVersion: 'v1'
}

# Como gerenciar Membros

A área de Membros reúne as pessoas que fazem parte do ambiente Personagrama e permite acompanhar sua situação de acesso e seus papéis.

<HelpImage pendingId="O01.1" alt="Tela de Membros do Personagrama" />

## Como utilizar

<Steps>
  <Step title="Abra Membros">Acesse a área administrativa de pessoas.</Step>
  <Step title="Localize o usuário">Use as informações disponíveis para identificar a pessoa correta.</Step>
  <Step title="Confira papel e status">Papel define o que a pessoa pode fazer; status indica sua situação de acesso.</Step>
  <Step title="Execute a ação necessária">Use somente as ações administrativas disponíveis para aquele membro.</Step>
</Steps>

<Callout type="important">Papel e status são informações diferentes. Um usuário pode ter um papel definido e ainda estar aguardando o primeiro acesso.</Callout>
